import React, { useEffect, useState } from "react";
import { fetchStripeLink } from "../../api/PricingAPI";

const Payments = () => {
  const [paymentLink, setPaymentLink] = useState(null);

  useEffect(() => {
    const getStripeLink = async () => {
      const stripeLink = await fetchStripeLink();
      setPaymentLink(stripeLink);
    };
    getStripeLink();
  }, []);

  useEffect(() => {
    if (paymentLink) {
      window.location.href = paymentLink;
    }
  }, [paymentLink]);

  return <div></div>;
};

export default Payments;
